var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sub-values" },
    [
      _vm.job.careerLevel
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Berufsebene")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("Label", {
                        attrs: {
                          characteristic: _vm.job.careerLevel,
                          "label-type": _vm.labelTypeApplication
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              75218116
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.job.functions && _vm.job.functions.length > 0
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Tätigkeiten")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("LabelList", {
                        attrs: {
                          characteristics: _vm.extractCharacteristic(
                            _vm.job.functions
                          ),
                          "label-type": _vm.labelTypeApplication,
                          "last-level-only": ""
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3257852305
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.job.industrialSectors && _vm.job.industrialSectors.length > 0
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Branchen")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("LabelList", {
                        attrs: {
                          characteristics: _vm.extractCharacteristic(
                            _vm.job.industrialSectors
                          ),
                          "label-type": _vm.labelTypeApplication,
                          "last-level-only": ""
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3575609285
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.job.organisationalArea && _vm.job.organisationalArea.length > 0
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Organisationsbereiche")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("LabelList", {
                        attrs: {
                          characteristics: _vm.extractCharacteristic(
                            _vm.job.organisationalArea
                          ),
                          "label-type": _vm.labelTypeApplication,
                          "last-level-only": ""
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2676125804
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.job.companyWebsite
        ? _c("InfoItem", {
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [_vm._v("Website")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [_vm._v(_vm._s(_vm.job.companyWebsite))]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3180175301
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.job.description
        ? _c("div", {
            staticClass: "mt-2",
            domProps: { innerHTML: _vm._s(_vm.job.description) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }